/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { JsonApiLinksDto } from "../JsonApiLinksDto";
import type { PaginationMeta } from "../PaginationMeta";

export type HierarchiesControllerGetChildrenPathParams = {
    /**
     * @description Parent scope ID
     * @type string
    */
    scopeId: string;
};

export const hierarchiesControllerGetChildrenQueryParamsScopeTypeEnum = {
    "ORGANIZATION": "ORGANIZATION",
    "PROMPT": "PROMPT",
    "FILE": "FILE",
    "PROJECT": "PROJECT",
    "SYSTEM": "SYSTEM",
    "WORKSPACE": "WORKSPACE",
    "TEAM": "TEAM",
    "FOLDER": "FOLDER",
    "USER": "USER",
    "CHAT_MESSAGE": "CHAT_MESSAGE",
    "CLIENT": "CLIENT",
    "THREAD": "THREAD",
    "PROJECT_TYPE": "PROJECT_TYPE",
    "OWNER": "OWNER",
    "ARCHITECT": "ARCHITECT",
    "DEPARTMENT": "DEPARTMENT",
    "REGION": "REGION",
    "CHECKLIST_TEMPLATE": "CHECKLIST_TEMPLATE",
    "TRIAL": "TRIAL",
    "CHANGE_ORDER": "CHANGE_ORDER",
    "SOURCE_RECORD": "SOURCE_RECORD",
    "all": "all"
} as const;

export type HierarchiesControllerGetChildrenQueryParamsScopeTypeEnumKey = (typeof hierarchiesControllerGetChildrenQueryParamsScopeTypeEnum)[keyof typeof hierarchiesControllerGetChildrenQueryParamsScopeTypeEnum];

export const hierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnum = {
    "PENDING": "PENDING",
    "UPLOADING": "UPLOADING",
    "UPLOADED": "UPLOADED",
    "PROCESSING": "PROCESSING",
    "READY": "READY",
    "FAILED": "FAILED",
    "ARCHIVED": "ARCHIVED",
    "DELETED": "DELETED",
    "VERSIONED": "VERSIONED"
} as const;

export type HierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnumKey = (typeof hierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnum)[keyof typeof hierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnum];

export const hierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnum = {
    "PRIME_CONTRACT": "PRIME_CONTRACT",
    "SUBCONTRACT": "SUBCONTRACT",
    "SPECIFICATIONS": "SPECIFICATIONS",
    "DRAWING": "DRAWING",
    "DRAWING_SET": "DRAWING_SET",
    "OTHER": "OTHER"
} as const;

export type HierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnumKey = (typeof hierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnum)[keyof typeof hierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnum];

export type HierarchiesControllerGetChildrenQueryParams = {
    /**
     * @description Type(s) of scope for filtering child scopes. Can be a single type or comma-separated list (e.g., FILE,FOLDER)
     * @type string | undefined
    */
    scopeType?: HierarchiesControllerGetChildrenQueryParamsScopeTypeEnumKey;
    /**
     * @description Maximum depth of hierarchy to retrieve
     * @minLength 1
     * @default 5
     * @type number | undefined
    */
    maxDepth?: number;
    /**
     * @description Load children lazily (returns links for children instead of full data)
     * @default false
     * @type boolean | undefined
    */
    lazyLoadChildren?: boolean;
    /**
     * @description Number of items per page
     * @minLength 1
     * @maxLength 100
     * @default 20
     * @type number | undefined
    */
    pageSize?: number;
    /**
     * @description Page number for offset-based pagination
     * @minLength 1
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description Sort field and order. Entity-based sorts: \"name\"/\"-name\" (entity name, case-insensitive), \"entityCreatedAt\"/\"-entityCreatedAt\", \"entityUpdatedAt\"/\"-entityUpdatedAt\", \"entityCreatedByUser\"/\"-entityCreatedByUser\" (creator full name), \"entityUpdatedByUser\"/\"-entityUpdatedByUser\" (updater full name), \"entityDocumentType\"/\"-entityDocumentType\" (file document type, alphabetical by label). Scope-based sorts: \"createdAt\"/\"-createdAt\", \"updatedAt\"/\"-updatedAt\".
     * @type string | undefined
    */
    sort?: string;
    /**
     * @description Search term to filter children by entity name, and description/referenceNumber for projects (case-insensitive partial match)
     * @type string | undefined
    */
    search?: string;
    /**
     * @description Include soft-deleted entities (teams, organizations, clients) in the response. Default is false.
     * @default false
     * @type boolean | undefined
    */
    includeDeleted?: boolean;
    /**
     * @description Return only archived projects, folders and files. This is what the Archive listing reads; it overrides includeArchived.
     * @default false
     * @type boolean | undefined
    */
    archiveView?: boolean;
    /**
     * @description Include archived projects, folders and files in the response. Default is false, so an archived item leaves the active listing the way a deleted one does.
     * @default false
     * @type boolean | undefined
    */
    includeArchived?: boolean;
    /**
     * @description Include the scope itself (the scopeId used in the request) in the ancestor results. Default is false.
     * @default false
     * @type boolean | undefined
    */
    includeSelf?: boolean;
    /**
     * @description File statuses to exclude from results. Can be a single status or comma-separated list (e.g., \"PENDING,UPLOADING\")
     * @type array | undefined
    */
    excludeFileStatuses?: HierarchiesControllerGetChildrenQueryParamsExcludeFileStatusesEnumKey[];
    /**
     * @description Document types to filter FILE children by. Can be a single type or comma-separated list (e.g., \"PRIME_CONTRACT,SUBCONTRACT\"). Unlike excludeFileStatuses, this narrows results to files only — non-FILE children (folders) are excluded while it is active.
     * @type array | undefined
    */
    fileDocumentTypes?: HierarchiesControllerGetChildrenQueryParamsFileDocumentTypesEnumKey[];
    /**
     * @description Load entity data (folder.name, file.fileName, etc.) so results carry real display names. Set false when only counts/structure are needed, to skip the entity joins. Default is true; ignored (forced on) when a search term is present, since name filtering requires it.
     * @default true
     * @type boolean | undefined
    */
    includeEntities?: boolean;
};

export const dataTypeEnum2899 = {
    "hierarchies": "hierarchies"
} as const;

export type DataTypeEnum2899Key = (typeof dataTypeEnum2899)[keyof typeof dataTypeEnum2899];

export const attributesTypeEnum8 = {
    "ORGANIZATION": "ORGANIZATION",
    "TEAM": "TEAM",
    "PROJECT": "PROJECT",
    "FILE": "FILE",
    "FOLDER": "FOLDER",
    "CLIENT": "CLIENT"
} as const;

export type AttributesTypeEnum8Key = (typeof attributesTypeEnum8)[keyof typeof attributesTypeEnum8];

export const dataTypeEnum2900 = {
    "organizations": "organizations"
} as const;

export type DataTypeEnum2900Key = (typeof dataTypeEnum2900)[keyof typeof dataTypeEnum2900];

export const dataTypeEnum2901 = {
    "teams": "teams"
} as const;

export type DataTypeEnum2901Key = (typeof dataTypeEnum2901)[keyof typeof dataTypeEnum2901];

export const dataTypeEnum2902 = {
    "projects": "projects"
} as const;

export type DataTypeEnum2902Key = (typeof dataTypeEnum2902)[keyof typeof dataTypeEnum2902];

export const dataTypeEnum2903 = {
    "files": "files"
} as const;

export type DataTypeEnum2903Key = (typeof dataTypeEnum2903)[keyof typeof dataTypeEnum2903];

export const dataTypeEnum2904 = {
    "folders": "folders"
} as const;

export type DataTypeEnum2904Key = (typeof dataTypeEnum2904)[keyof typeof dataTypeEnum2904];

export const dataTypeEnum2905 = {
    "clients": "clients"
} as const;

export type DataTypeEnum2905Key = (typeof dataTypeEnum2905)[keyof typeof dataTypeEnum2905];

export const includedTypeEnum2042 = {
    "hierarchies": "hierarchies"
} as const;

export type IncludedTypeEnum2042Key = (typeof includedTypeEnum2042)[keyof typeof includedTypeEnum2042];

export const includedTypeEnum2043 = {
    "organizations": "organizations"
} as const;

export type IncludedTypeEnum2043Key = (typeof includedTypeEnum2043)[keyof typeof includedTypeEnum2043];

export const dataTypeEnum2906 = {
    "scopes": "scopes"
} as const;

export type DataTypeEnum2906Key = (typeof dataTypeEnum2906)[keyof typeof dataTypeEnum2906];

export const dataTypeEnum2907 = {
    "trial-summaries": "trial-summaries"
} as const;

export type DataTypeEnum2907Key = (typeof dataTypeEnum2907)[keyof typeof dataTypeEnum2907];

export const dataTypeEnum2908 = {
    "domains": "domains"
} as const;

export type DataTypeEnum2908Key = (typeof dataTypeEnum2908)[keyof typeof dataTypeEnum2908];

export const includedTypeEnum2044 = {
    "teams": "teams"
} as const;

export type IncludedTypeEnum2044Key = (typeof includedTypeEnum2044)[keyof typeof includedTypeEnum2044];

export const dataTypeEnum2909 = {
    "users": "users"
} as const;

export type DataTypeEnum2909Key = (typeof dataTypeEnum2909)[keyof typeof dataTypeEnum2909];

export const dataTypeEnum2910 = {
    "principals": "principals"
} as const;

export type DataTypeEnum2910Key = (typeof dataTypeEnum2910)[keyof typeof dataTypeEnum2910];

export const dataTypeEnum2911 = {
    "offices": "offices"
} as const;

export type DataTypeEnum2911Key = (typeof dataTypeEnum2911)[keyof typeof dataTypeEnum2911];

export const includedTypeEnum2045 = {
    "projects": "projects"
} as const;

export type IncludedTypeEnum2045Key = (typeof includedTypeEnum2045)[keyof typeof includedTypeEnum2045];

export const dataTypeEnum2912 = {
    "sample-project-templates": "sample-project-templates"
} as const;

export type DataTypeEnum2912Key = (typeof dataTypeEnum2912)[keyof typeof dataTypeEnum2912];

export const dataTypeEnum2913 = {
    "project-types": "project-types"
} as const;

export type DataTypeEnum2913Key = (typeof dataTypeEnum2913)[keyof typeof dataTypeEnum2913];

export const dataTypeEnum2914 = {
    "owners": "owners"
} as const;

export type DataTypeEnum2914Key = (typeof dataTypeEnum2914)[keyof typeof dataTypeEnum2914];

export const dataTypeEnum2915 = {
    "architects": "architects"
} as const;

export type DataTypeEnum2915Key = (typeof dataTypeEnum2915)[keyof typeof dataTypeEnum2915];

export const dataTypeEnum2916 = {
    "departments": "departments"
} as const;

export type DataTypeEnum2916Key = (typeof dataTypeEnum2916)[keyof typeof dataTypeEnum2916];

export const dataTypeEnum2917 = {
    "regions": "regions"
} as const;

export type DataTypeEnum2917Key = (typeof dataTypeEnum2917)[keyof typeof dataTypeEnum2917];

export const dataTypeEnum2918 = {
    "external-project-links": "external-project-links"
} as const;

export type DataTypeEnum2918Key = (typeof dataTypeEnum2918)[keyof typeof dataTypeEnum2918];

export const includedTypeEnum2046 = {
    "files": "files"
} as const;

export type IncludedTypeEnum2046Key = (typeof includedTypeEnum2046)[keyof typeof includedTypeEnum2046];

export const includedTypeEnum2047 = {
    "folders": "folders"
} as const;

export type IncludedTypeEnum2047Key = (typeof includedTypeEnum2047)[keyof typeof includedTypeEnum2047];

export const includedTypeEnum2048 = {
    "clients": "clients"
} as const;

export type IncludedTypeEnum2048Key = (typeof includedTypeEnum2048)[keyof typeof includedTypeEnum2048];

export const includedTypeEnum2049 = {
    "scopes": "scopes"
} as const;

export type IncludedTypeEnum2049Key = (typeof includedTypeEnum2049)[keyof typeof includedTypeEnum2049];

export const includedTypeEnum2050 = {
    "trial-summaries": "trial-summaries"
} as const;

export type IncludedTypeEnum2050Key = (typeof includedTypeEnum2050)[keyof typeof includedTypeEnum2050];

export const includedTypeEnum2051 = {
    "domains": "domains"
} as const;

export type IncludedTypeEnum2051Key = (typeof includedTypeEnum2051)[keyof typeof includedTypeEnum2051];

export const includedTypeEnum2052 = {
    "users": "users"
} as const;

export type IncludedTypeEnum2052Key = (typeof includedTypeEnum2052)[keyof typeof includedTypeEnum2052];

export const dataTypeEnum2919 = {
    "user-preferences": "user-preferences"
} as const;

export type DataTypeEnum2919Key = (typeof dataTypeEnum2919)[keyof typeof dataTypeEnum2919];

export const includedTypeEnum2053 = {
    "offices": "offices"
} as const;

export type IncludedTypeEnum2053Key = (typeof includedTypeEnum2053)[keyof typeof includedTypeEnum2053];

export const includedTypeEnum2054 = {
    "principals": "principals"
} as const;

export type IncludedTypeEnum2054Key = (typeof includedTypeEnum2054)[keyof typeof includedTypeEnum2054];

export const dataTypeEnum2920 = {
    "members": "members"
} as const;

export type DataTypeEnum2920Key = (typeof dataTypeEnum2920)[keyof typeof dataTypeEnum2920];

export const dataTypeEnum2921 = {
    "principalRoles": "principalRoles"
} as const;

export type DataTypeEnum2921Key = (typeof dataTypeEnum2921)[keyof typeof dataTypeEnum2921];

export const includedTypeEnum2055 = {
    "sample-project-templates": "sample-project-templates"
} as const;

export type IncludedTypeEnum2055Key = (typeof includedTypeEnum2055)[keyof typeof includedTypeEnum2055];

export const includedTypeEnum2056 = {
    "project-types": "project-types"
} as const;

export type IncludedTypeEnum2056Key = (typeof includedTypeEnum2056)[keyof typeof includedTypeEnum2056];

export const includedTypeEnum2057 = {
    "owners": "owners"
} as const;

export type IncludedTypeEnum2057Key = (typeof includedTypeEnum2057)[keyof typeof includedTypeEnum2057];

export const includedTypeEnum2058 = {
    "architects": "architects"
} as const;

export type IncludedTypeEnum2058Key = (typeof includedTypeEnum2058)[keyof typeof includedTypeEnum2058];

export const includedTypeEnum2059 = {
    "departments": "departments"
} as const;

export type IncludedTypeEnum2059Key = (typeof includedTypeEnum2059)[keyof typeof includedTypeEnum2059];

export const includedTypeEnum2060 = {
    "regions": "regions"
} as const;

export type IncludedTypeEnum2060Key = (typeof includedTypeEnum2060)[keyof typeof includedTypeEnum2060];

export const includedTypeEnum2061 = {
    "external-project-links": "external-project-links"
} as const;

export type IncludedTypeEnum2061Key = (typeof includedTypeEnum2061)[keyof typeof includedTypeEnum2061];

export const includedTypeEnum2062 = {
    "user-preferences": "user-preferences"
} as const;

export type IncludedTypeEnum2062Key = (typeof includedTypeEnum2062)[keyof typeof includedTypeEnum2062];

export const includedTypeEnum2063 = {
    "members": "members"
} as const;

export type IncludedTypeEnum2063Key = (typeof includedTypeEnum2063)[keyof typeof includedTypeEnum2063];

export const dataTypeEnum2922 = {
    "roles": "roles"
} as const;

export type DataTypeEnum2922Key = (typeof dataTypeEnum2922)[keyof typeof dataTypeEnum2922];

export const dataTypeEnum2923 = {
    "scope-access": "scope-access"
} as const;

export type DataTypeEnum2923Key = (typeof dataTypeEnum2923)[keyof typeof dataTypeEnum2923];

export const includedTypeEnum2064 = {
    "principalRoles": "principalRoles"
} as const;

export type IncludedTypeEnum2064Key = (typeof includedTypeEnum2064)[keyof typeof includedTypeEnum2064];

export type HierarchiesControllerGetChildren200 = {
    /**
     * @type array
    */
    data: {
        /**
         * @type string
        */
        id: string;
        type: DataTypeEnum2899Key;
        /**
         * @description Resource attributes (excluding relationships)
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            type?: AttributesTypeEnum8Key;
            parentId?: (string | null);
            /**
             * @type number | undefined
            */
            depth?: number;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type boolean | undefined
            */
            private?: boolean;
            /**
             * @type string | undefined
            */
            name?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            archivedAt?: (string | null);
            organization?: (object | null);
            team?: (object | null);
            project?: (object | null);
            file?: (object | null);
            folder?: (object | null);
            client?: (object | null);
            /**
             * @type boolean | undefined
            */
            isArchived?: boolean;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2899Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2899Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2900Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2901Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2902Key;
                });
            };
            /**
             * @type object | undefined
            */
            file?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2903Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2904Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2905Key;
                });
            };
        };
    }[];
    /**
     * @description Additional resources referenced by the data
     * @type array | undefined
    */
    included?: ({
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2042Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            parentId?: string;
            /**
             * @type string | undefined
            */
            depth?: string;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type string | undefined
            */
            private?: string;
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            organization?: string;
            /**
             * @type string | undefined
            */
            team?: string;
            /**
             * @type string | undefined
            */
            project?: string;
            /**
             * @type string | undefined
            */
            file?: string;
            /**
             * @type string | undefined
            */
            folder?: string;
            /**
             * @type string | undefined
            */
            client?: string;
            /**
             * @type string | undefined
            */
            isArchived?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2899Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2899Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2900Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2901Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2902Key;
                });
            };
            /**
             * @type object | undefined
            */
            file?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2903Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2904Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2905Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2043Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            trimbleIamAccountId?: string;
            /**
             * @type string | undefined
            */
            trimbleCdhAccountId?: string;
            /**
             * @type string | undefined
            */
            ssoEnabled?: string;
            /**
             * @type string | undefined
            */
            dataProtectionEnabled?: string;
            /**
             * @type string | undefined
            */
            organizationSkillsEnabled?: string;
            /**
             * @type string | undefined
            */
            emsValidationEnabled?: string;
            /**
             * @type string | undefined
            */
            archivedProjectChatEnabled?: string;
            /**
             * @type string | undefined
            */
            archivedContentChatEnabled?: string;
            /**
             * @type string | undefined
            */
            apiAccessEnabled?: string;
            /**
             * @type string | undefined
            */
            isInternal?: string;
            /**
             * @type string | undefined
            */
            enabledIntegrations?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
            /**
             * @type string | undefined
            */
            entitlement?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            trial?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2907Key;
                });
            };
            /**
             * @type object | undefined
            */
            clients?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2905Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            domains?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2908Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            teams?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2901Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            folders?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2904Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            files?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2903Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2899Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            descendants?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2899Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2044Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2900Key;
                });
            };
            /**
             * @type object | undefined
            */
            members?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            sourceOffice?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2911Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2045Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            visibility?: string;
            /**
             * @type string | undefined
            */
            stage?: string;
            /**
             * @type string | undefined
            */
            location?: string;
            /**
             * @type string | undefined
            */
            startDate?: string;
            /**
             * @type string | undefined
            */
            endDate?: string;
            /**
             * @type string | undefined
            */
            description?: string;
            /**
             * @type string | undefined
            */
            value?: string;
            /**
             * @type string | undefined
            */
            referenceNumber?: string;
            /**
             * @type string | undefined
            */
            deliverable?: string;
            /**
             * @type string | undefined
            */
            deliveryMethod?: string;
            /**
             * @type string | undefined
            */
            division?: string;
            /**
             * @type string | undefined
            */
            details?: string;
            /**
             * @type string | undefined
            */
            imageUrl?: string;
            /**
             * @type string | undefined
            */
            workflowCount?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            sampleProjectTemplate?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2912Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2905Key;
                });
            };
            /**
             * @type object | undefined
            */
            projectType?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2913Key;
                });
            };
            /**
             * @type object | undefined
            */
            owner?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2914Key;
                });
            };
            /**
             * @type object | undefined
            */
            architect?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2915Key;
                });
            };
            /**
             * @type object | undefined
            */
            department?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2916Key;
                });
            };
            /**
             * @type object | undefined
            */
            region?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2917Key;
                });
            };
            /**
             * @type object | undefined
            */
            projectLead?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            externalLinks?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2918Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2046Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            fileUuid?: string;
            /**
             * @type string | undefined
            */
            originalName?: string;
            /**
             * @type string | undefined
            */
            fileName?: string;
            /**
             * @type string | undefined
            */
            mimeType?: string;
            /**
             * @type string | undefined
            */
            fileSize?: string;
            /**
             * @type string | undefined
            */
            checksum?: string;
            /**
             * @type string | undefined
            */
            bucket?: string;
            /**
             * @type string | undefined
            */
            fileKey?: string;
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            fileDocumentType?: string;
            /**
             * @type string | undefined
            */
            processingStartedAt?: string;
            /**
             * @type string | undefined
            */
            processingCompletedAt?: string;
            /**
             * @type string | undefined
            */
            pageCount?: string;
            /**
             * @type string | undefined
            */
            duration?: string;
            /**
             * @type string | undefined
            */
            dimensions?: string;
            /**
             * @type string | undefined
            */
            metadata?: string;
            /**
             * @type string | undefined
            */
            scopeType?: string;
            /**
             * @type string | undefined
            */
            version?: string;
            /**
             * @type string | undefined
            */
            versionName?: string;
            /**
             * @type string | undefined
            */
            versionDescription?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            isArchived?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            rootFile?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2903Key;
                });
            };
            /**
             * @type object | undefined
            */
            versions?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2903Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2047Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2048Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2900Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2902Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2049Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            parentId?: string;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type string | undefined
            */
            depth?: string;
            /**
             * @type string | undefined
            */
            private?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2900Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2901Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2904Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2902Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2050Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            projectCount?: string;
            /**
             * @type string | undefined
            */
            projectCap?: string;
            /**
             * @type string | undefined
            */
            expiresAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2051Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2900Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2052Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            email?: string;
            /**
             * @type string | undefined
            */
            firstName?: string;
            /**
             * @type string | undefined
            */
            lastName?: string;
            /**
             * @type string | undefined
            */
            phoneNumber?: string;
            /**
             * @type string | undefined
            */
            companyRole?: string;
            /**
             * @type string | undefined
            */
            acceptedTerms?: string;
            /**
             * @type string | undefined
            */
            termsAcceptedAt?: string;
            /**
             * @type string | undefined
            */
            lastLoginAt?: string;
            /**
             * @type string | undefined
            */
            timezone?: string;
            /**
             * @type string | undefined
            */
            avatarUrl?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            changeOrderAccess?: string;
            /**
             * @type string | undefined
            */
            trimbleSub?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            preferences?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2919Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2053Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            uuid?: string;
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            isActive?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2054Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            displayName?: string;
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            cognitoSubs?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            memberships?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2920Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            createdFiles?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2903Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            roles?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2921Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2055Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            status?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2056Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2900Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2902Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2057Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2900Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2902Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2058Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2900Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2902Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2059Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2900Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2902Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2060Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2900Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2902Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2061Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            provider?: string;
            /**
             * @type string | undefined
            */
            externalCompanyId?: string;
            /**
             * @type string | undefined
            */
            externalProjectId?: string;
            /**
             * @type string | undefined
            */
            scopeId?: string;
            /**
             * @type string | undefined
            */
            metadata?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2902Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2062Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            currentTeamId?: string;
            /**
             * @type string | undefined
            */
            theme?: string;
            /**
             * @type string | undefined
            */
            language?: string;
            /**
             * @type string | undefined
            */
            timezoneOverride?: string;
            /**
             * @type string | undefined
            */
            dashboardLayout?: string;
            /**
             * @type string | undefined
            */
            onboardingStatus?: string;
            /**
             * @type string | undefined
            */
            onboardingGoals?: string;
            /**
             * @type string | undefined
            */
            onboardingCompletedAt?: string;
            /**
             * @type string | undefined
            */
            skillsEducationDismissedAt?: string;
            /**
             * @type string | undefined
            */
            onboardingTaskCompletions?: string;
            /**
             * @type string | undefined
            */
            onboardingTasksLoginViews?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            currentTeam?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2901Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2063Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            membershipType?: string;
            /**
             * @type string | undefined
            */
            email?: string;
            /**
             * @type string | undefined
            */
            firstName?: string;
            /**
             * @type string | undefined
            */
            lastName?: string;
            /**
             * @type string | undefined
            */
            displayName?: string;
            /**
             * @type string | undefined
            */
            roleName?: string;
            /**
             * @type string | undefined
            */
            expiresAt?: string;
            /**
             * @type string | undefined
            */
            message?: string;
            /**
             * @type string | undefined
            */
            inviteStatus?: string;
            /**
             * @type string | undefined
            */
            isInherited?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            role?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2922Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2909Key;
                });
            };
            /**
             * @type object | undefined
            */
            invitedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            inheritedFrom?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            scopeAccess?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2923Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2064Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            expiresAt?: string;
            /**
             * @type string | undefined
            */
            scopeType?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2910Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2906Key;
                });
            };
            /**
             * @type object | undefined
            */
            role?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum2922Key;
                });
            };
        };
    })[];
    /**
     * @type object | undefined
    */
    meta?: PaginationMeta;
    /**
     * @type object | undefined
    */
    links?: JsonApiLinksDto;
};

/**
 * @description Unauthorized
*/
export type HierarchiesControllerGetChildren401 = any;

/**
 * @description Forbidden - insufficient permissions
*/
export type HierarchiesControllerGetChildren403 = any;

export type HierarchiesControllerGetChildrenQueryResponse = HierarchiesControllerGetChildren200;

export type HierarchiesControllerGetChildrenQuery = {
    Response: HierarchiesControllerGetChildren200;
    PathParams: HierarchiesControllerGetChildrenPathParams;
    QueryParams: HierarchiesControllerGetChildrenQueryParams;
    Errors: HierarchiesControllerGetChildren401 | HierarchiesControllerGetChildren403;
};